<template>
  <v-form @submit.prevent="saveProfile">
    <v-container>
      <v-layout row wrap>
        <v-flex xs12 md4>
          <v-text-field label="Email" v-model="profile.email"></v-text-field>
        </v-flex>
        <v-flex xs12 md4>
          <v-text-field label="Name" v-model="profile.name"></v-text-field>
        </v-flex>
        <v-flex xs12 md4>
          <v-text-field label="Phone" v-model="profile.phone"></v-text-field>
        </v-flex>
        <v-flex xs12 md4>
          <v-text-field label="Status" v-model="profile.status"></v-text-field>
        </v-flex>

        <v-flex xs12 md4>
          <v-text-field label="Membership Type" v-model="profile.membershipType"></v-text-field>
        </v-flex>
        <v-flex xs12 md4>
          <v-text-field label="Membership Number" v-model="profile.membershipNumber"></v-text-field>
        </v-flex>
        <v-flex xs12 md4>
          <date-input v-model="profile.membershipStart" label="Membership Start Date"></date-input>
        </v-flex>

        <v-btn type="submit" color="primary">Save</v-btn>
      </v-layout>
    </v-container>
  </v-form>
</template>

<script>
import { Database } from '@/library/firebase'
import DateInput from '@/components/forms/DateInput'

export default {
  components: {
    DateInput
  },
  props: {
    userId: String
  },
  data () {
    return {
      profile: {
        email: null,
        name: null,
        phone: null,
        status: null,
        membershipType: null,
        membershipNumber: null,
        membershipStart: null
      }
    }
  },
  methods: {
    getProfile () {
      Database.ref('users').child(this.userId).once('value', data => {
        if (data.val()) {
          this.profile = data.val()
        }
      })
    },
    saveProfile () {
      Database.ref('users').child(this.userId).set(this.profile)

      this.$toasted.success('Saved', { duration: 2000 })
    }
  },
  created () {
    this.getProfile()
  }
}
</script>

<style>
</style>
